<script lang="ts" setup>

import { useAppBrand } from '@shared/lib/app-brand'

import LinkWhatsApp from './LinkWhatsApp.vue'
import LinkSendEmail from './LinkSendEmail.vue'
import LinkSendSms from './LinkSendSms.vue'

defineOptions({
  name: 'DropdownSupport',
})

const { isSmartestMinds } = useAppBrand()

</script>

<template>
  <LinkWhatsApp v-if="!isSmartestMinds" />
  <LinkSendEmail />
  <LinkSendSms />
</template>
